<script>
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
@Component({
  name: "multiline-print"
})
export default class multilinePrint extends Vue {
  @Prop({ type: [Array, Object], default: () => [] }) info;
  render(h) {
    const isArray = Array.isArray(this.info);
    if (isArray === true) {
      return (
        <div class="multilinePrint-table">
          {this.info.map(item => {
            return renderTable(item);
          })}
        </div>
      );
    } else {
      return (
        this.info.hide ? '' : <div class="multilinePrint-app" style={formatStyle(this.info.style)}>
          {this.info.children && this.info.children.length > 0 ? (
            this.info.children.map(item => renderTable(item))
          ) : (
            <div
              class="multilinePrint-app__last"
              style={formatStyle(this.info.style)}
            >
              {this.info.render
                ? this.info.render(h, this.info)
                : <span class={this.info.textStyle ? 'text-style' : ''} style={formatStyle(this.info.textStyle)}><span class={this.info.borderNone ? this.info.borderNone : this.info.borderDouble ? 'border-double' : ''}><span class={this.info.borderDouble ? 'border-double' : ''}>{this.info.text} {this.info.borderDouble}</span></span></span>}
            </div>
          )}
        </div>
      );
    }

    function renderTable(item) {
      return <multiline-print {...{ props: { info: item } }}></multiline-print>;
    }
    function formatStyle(info) {
      if (info) return { ...info };
      return {};
    }
  }
}
</script>

<style lang="scss">
.multilinePrint-table {
  @import "src/sass/index";
  @import "src/sass/modules/mixin";
  display: flex;
}
.multilinePrint-app {
  display: flex;
  & > div {
    overflow: hidden;
    flex: 1;
  }
}
.multilinePrint-app {
  word-break: break-all;
}
.multilinePrint-app__last {
  border: 1px solid #666;
}
.text-style {
  -webkit-transform-origin-x: 0;
  -webkit-transform-origin-y: 0;
  display: inline-block;
}
.border-double {
  display: inline-block;
  padding: 2px;
  border: 1px solid;
}
.border-none {
  display: inline-block;
  padding: 2px;
  border: none;
}
.right-border {
  display: inline-block;
  padding: 2px;
  border: none;
  border-right: 1px solid;
}
.top-border-none {
  border-top: none;
}
.left-border-none {
  border-left: none;
}
</style>
